// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__8RHVa","col":"CardReaderDesc_col__3JVGY","label":"CardReaderDesc_label__3_5K7"};